var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !this.$route.query.hide
    ? _c("div", { staticClass: "nav_top" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "user item",
            attrs: { slot: "reference" },
            slot: "reference",
          },
          [
            _c("span", [
              _c("img", { attrs: { src: _vm.img } }),
              _c(
                "p",
                { staticClass: "user-name", staticStyle: { height: "24px" } },
                [_vm._v(_vm._s(_vm.userName))]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("div", { staticClass: "g-logo-big" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }